import React from 'react';
import { today } from '../helpers/dateFormatters';
import { CalendarViewResultPreview } from './ResultPreview/CalendarViewResultPreview';
import { ICalendarDate, ICalendarType } from '../Calendar';
import { CalendarViewNavigation } from './Navigation/CalendarViewNavigation';
import { CalendarViewCellsGrid } from './CellsGrid/CalendarViewCellsGrid';
import { NamedDaysAddon } from './NamedDaysAddon/NamedDaysAddon';
require("./CalendarView.css");
var styles = {
  "Root": "CalendarView-module-Root_DP6"
};
import { IDateFormat } from '../helpers/validators';
export const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
export const weekdays = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
export const CalendarView = ({
  calendarType = 'single',
  dateFormat = 'YYYY.MM.DD',
  selectedDateOne,
  selectedDateTwo,
  onClickDate = () => {},
  onIncrementMonthIndex = () => {},
  onDecrementMonthIndex = () => {},
  onChangeViewYear = () => {},
  currentView,
  position = 'primary',
  includeDayNavigation = false,
  includeResultPreview = false,
  includeTailsFromOtherMonths = false,
  selectDatesFrom,
  selectDatesTill,
  selectYearsFrom = today.year - 10,
  selectYearsTill = today.year + 10,
  separator = '.',
  disabledDates = []
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Content
  }, includeResultPreview && /*#__PURE__*/React.createElement(CalendarViewResultPreview, {
    calendarPosition: position,
    selectedDateOne: selectedDateOne,
    selectedDateTwo: selectedDateTwo,
    dateFormat: dateFormat,
    separator: separator
  }), /*#__PURE__*/React.createElement(CalendarViewNavigation, {
    calendarType: calendarType,
    currentView: currentView,
    calendarPosition: position,
    selectYearsFrom: selectYearsFrom,
    selectYearsTill: selectYearsTill,
    onChangeViewYear: onChangeViewYear,
    onDecrementMonthIndex: onDecrementMonthIndex,
    onIncrementMonthIndex: onIncrementMonthIndex
  }), /*#__PURE__*/React.createElement(CalendarViewCellsGrid, {
    calendarType: calendarType,
    currentView: currentView,
    calendarPosition: position,
    includeTailsFromOtherMonths: includeTailsFromOtherMonths,
    selectedDateOne: selectedDateOne,
    selectedDateTwo: selectedDateTwo,
    selectDatesFrom: selectDatesFrom,
    selectDatesTill: selectDatesTill,
    disabledDates: disabledDates,
    onClickDate: onClickDate
  })), includeDayNavigation && /*#__PURE__*/React.createElement(NamedDaysAddon, {
    calendarType: calendarType,
    calendarPosition: position,
    onClickDate: onClickDate
  }));
};